import { Flex } from "../../components/Flex";
import { Paragraph } from "../../components/Paragraph";
import { StatusBadge, StatusIntent } from "../../components/StatusBadge";
import { CheckStatusEnum } from "../../context/MandateStatusContext";
import { checksStatusName } from "./helper";

type Props = {
  status: string;
  statusText?: string;
  flush?: boolean;
};

const CHECK_STATUS_INTENT: Record<string, StatusIntent> = {
  [CheckStatusEnum.Review]: "warning",
  [CheckStatusEnum.Pending]: "info",
  [CheckStatusEnum.Accepted]: "success",
  [CheckStatusEnum.ManuallyAccepted]: "success",
  [CheckStatusEnum.ManuallyRejected]: "danger",
};

/** The check's overall result: one slim line with a status badge. */
export const CheckResults = (props: Props) => {
  const { status, statusText = "", flush = false } = props;

  return (
    <Flex alignItems="center" gap="8" px={flush ? 0 : 4} mb={2}>
      <Paragraph m="0px" fontSize={1} color="gray.50">
        Check result
      </Paragraph>
      <StatusBadge intent={CHECK_STATUS_INTENT[status] ?? "neutral"}>
        {statusText ? statusText : checksStatusName[status] ?? status}
      </StatusBadge>
    </Flex>
  );
};
